import "../Styles/Main.css";
import { CheckCircle } from "lucide-react";
import { useLang } from "../i18n/useLang";

function MainContent() {
  const { t } = useLang();
  const c = t.home.hero;

  return (
    <div className="qc-hero" aria-label="Hero section">
      <div className="qc-hero__badgeWrap">
        <span className="qc-hero__badge">{c.badge}</span>
      </div>

      {/* Single H1 for SEO */}
      <h1 className="qc-hero__title">
        <span className="qc-hero__titleLine">{c.titleLine1}</span>
        <span className="qc-hero__titleLine">{c.titleLine2}</span>
      </h1>

      <p className="qc-hero__sub">
        <span className="qc-hero__subLine">{c.descriptionLine1}</span>
        <span className="qc-hero__subLine">{c.descriptionLine2}</span>
      </p>

      <a className="qc-hero__cta btn btn-primary" href="#contact">
        {c.cta}
      </a>

      <div className="qc-hero__checks" aria-label="Key services">
        {c.checks.map((item) => (
          <div className="qc-hero__check" key={item}>
            <CheckCircle
              className="qc-hero__checkIcon"
              aria-hidden="true"
              focusable="false"
              size={20}
            />
            <span className="qc-hero__checkText">{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MainContent;
